import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import moment from "moment";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import SearchButton from "../../components/common/SearchButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import { Link, useNavigate } from "react-router-dom";
import PageBar from "../../components/common/PageBar";
import SearchInput from "../../components/common/SearchInput";
import CustomDropDownTreeSelect from "../../components/common/CustomDropDownTreeSelect";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";

const ItemCodeManagementPage = () => {
  const navigate = useNavigate();
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();

  const pageSize = 10;
  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [groupCode, setGroupCode] = useState("");
  const [typeCode, setTypeCode] = useState([]);
  const searchGroupCode = useRef("");
  const searchTypeCode = useRef([]);

  const [sbTypeCode, setSbTypeCode] = useState([]);
  const [datas, setDatas] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const loadTypeCodeData = () => {
    if (sbTypeCode != null && sbTypeCode.length > 0) {
      return;
    }

    api
      .post("/common/itemtype-tree", {})
      .then((response) => {
        setSbTypeCode(response.data);
      })
      .catch(() => {});
  };

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/itemcode/view", {
        sCode: searchGroupCode.current,
        sTypeCodes: searchTypeCode.current,
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setTotalCount(response.data.totalCount);
        setDatas(response.data.content);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  const handleGroupCodeChange = (e) => {
    setGroupCode(e.target.value.trim());
  };

  const handleSearch = () => {
    searchGroupCode.current = groupCode;
    searchTypeCode.current = typeCode;

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handleAddCode = () => {
    navigate("/manage/itemcode/edit");
  };

  const handleExcelDownload = () => {
    if (isExcelLoading) {
      return;
    }
    setIsExcelLoading(true);
    api
      .post(
        "/manage/itemcode/excel",
        {
          sCode: searchGroupCode.current,
          sTypeCodes: searchTypeCode.current,
        },
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          "Item_Code_" + moment().format("YYYYMMDD") + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        setIsExcelLoading(false);
      })
      .catch(() => {
        setIsExcelLoading(false);
      });
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0086")]}></BreadCrumbDiv>

      <SearchWrapDiv>
        <ButtonWrapDiv>
          <SearchInput
            value={groupCode}
            onChange={handleGroupCodeChange}
            placeholder="Group Code"
            maxLength={10}
          ></SearchInput>
          <CustomDropDownTreeSelect
            data={sbTypeCode}
            placeholder={t("L0692")}
            isViewCode={false}
            onChange={setTypeCode}
            onFocus={loadTypeCodeData}
          ></CustomDropDownTreeSelect>
          <SearchButton onClick={handleSearch}></SearchButton>
        </ButtonWrapDiv>
      </SearchWrapDiv>

      <ButtonWrapDiv className="btn_top">
        {menuAuthInfo.reg && (
          <FunctionButton
            value={t("L0321")}
            onClick={handleAddCode}
          ></FunctionButton>
        )}
        {menuAuthInfo.view && (
          <FunctionButton
            value={t("L0150")}
            onClick={handleExcelDownload}
            loading={isExcelLoading}
          ></FunctionButton>
        )}
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "auto" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>{t("L0159")}</th>
                <th>{t("L0164")}</th>
                <th>{t("L0165")}</th>
                <th>{t("L0114")}</th>
                <th>{t("L0115")}</th>
                <th>{t("L0104")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={11} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{data.majorCode}</td>
                    <td>{data.middleCode}</td>
                    <td>{data.minorCode}</td>
                    <td style={{ textAlign: "left" }}>
                      {menuAuthInfo.view ? (
                        <Link
                          to="/manage/itemcode/edit"
                          state={{
                            majorCode: data["majorCode"],
                            middleCode: data["middleCode"],
                            minorCode: data["minorCode"],
                          }}
                        >
                          <span>
                            {data.minorCode !== "0" && data.parentDesc
                              ? `${data.parentDesc}_${data.desc || ""}`
                              : data.desc || ""}
                          </span>
                        </Link>
                      ) : (
                        <span>
                          {data.minorCode !== "0" && data.parentDesc
                            ? `${data.parentDesc}_${data.desc || ""}`
                            : data.desc || ""}
                        </span>
                      )}
                    </td>
                    <td>{data.createId}</td>
                    <td>
                      {data.createDT ? moment(data.createDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>
    </div>
  );
};

export default ItemCodeManagementPage;
